import { application, every } from './_common';

export default [
  ...every,
  ...application,
  {
    icon: 'mdi-account-group-outline',
    text: 'Пользователи',
    to: '/users',
    order: 5,
  },
];
